<template>
  <div>
    <!-- 超管 -->
    <div v-if="type === 0" class="pandect-module">
      <el-row type="flex" align="middle" class="module-title-line">
        <i class="title-icon icon-trend" />
        <p class="title-text">退费数据看板</p>
      </el-row>
      <div class="total-data-plane">
        <el-row type="flex" justify="space-between" align="middle" class="plane-container total-plane plane-line">
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">平台全部班型已退费工单（笔）</p>
              <p class="content-num">{{ data.platTotalNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">合计退费（元）</p>
              <p class="content-num">{{ [data.platTotalAmt, 2] | toLocalString }}</p>
            </div>
          </div>
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">合计基础班已退费工单（笔）</p>
              <p class="content-num">{{ data.platBaseNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">合计退费（元）</p>
              <p class="content-num">{{ [data.platBaseAmt, 2] | toLocalString }}</p>
            </div>
          </div>
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">合计标准班已退费工单（笔）</p>
              <p class="content-num">{{ data.platStandardNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">合计退费（元）</p>
              <p class="content-num">{{ [data.platStandardAmt, 2] | toLocalString }}</p>
            </div>
          </div>
        </el-row>
        <div class="plane-container">
          <el-row type="flex" justify="space-between" align="middle" class="plane-line">
            <div class="plane-item">
              <div class="plane-item-content">
                <p class="content-name">各代理全部班型已退费工单（笔）</p>
                <p class="content-num">{{ data.agentTotalNum | toLocalString }}</p>
              </div>
              <div class="plane-item-content">
                <p class="content-name">退费（元）</p>
                <p class="content-num">{{ [data.agentTotalAmt, 2] | toLocalString }}</p>
              </div>
            </div>
            <div class="plane-item">
              <div class="plane-item-content">
                <p class="content-name">基础班已退费工单（笔）</p>
                <p class="content-num">{{ data.agentBaseNum | toLocalString }}</p>
              </div>
              <div class="plane-item-content">
                <p class="content-name">退费（元）</p>
                <p class="content-num">{{ [data.agentBaseAmt, 2] | toLocalString }}</p>
              </div>
            </div>
            <div class="plane-item">
              <div class="plane-item-content">
                <p class="content-name">标准班已退费工单（笔）</p>
                <p class="content-num">{{ data.agentStandardNum | toLocalString }}</p>
              </div>
              <div class="plane-item-content">
                <p class="content-name">退费（元）</p>
                <p class="content-num">{{ [data.agentStandardAmt, 2] | toLocalString }}</p>
              </div>
            </div>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 教务服务方 -->
    <div v-else-if="type === 1" class="pandect-module">
      <el-row type="flex" align="middle" class="module-title-line">
        <i class="title-icon icon-trend" />
        <p class="title-text">教务服务方总数据</p>
      </el-row>
      <div class="total-data-plane">
        <el-row type="flex" justify="space-between" align="middle" class="plane-container total-plane plane-line">
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">全部班型合计已退费工单（笔）</p>
              <p class="content-num">{{ data.totalNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">合计退费（元）</p>
              <p class="content-num">{{ [data.totalAmt, 2] | toLocalString }}</p>
            </div>
          </div>
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">基础班合计已退费工单（笔）</p>
              <p class="content-num">{{ data.baseNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">合计退费（元）</p>
              <p class="content-num">{{ [data.baseAmt, 2] | toLocalString }}</p>
            </div>
          </div>
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">标准班合计已退费工单（笔）</p>
              <p class="content-num">{{ data.standardNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">合计退费（元）</p>
              <p class="content-num">{{ [data.standardAmt, 2] | toLocalString }}</p>
            </div>
          </div>
        </el-row>
        <div class="plane-container">
          <el-row type="flex" justify="space-between" align="middle" class="plane-line">
            <div class="plane-item">
              <div class="plane-item-content">
                <p class="content-name">当前教务服务方全部班型已退费工单（笔）</p>
                <p class="content-num">{{ data.currentTotalNum | toLocalString }}</p>
              </div>
              <div class="plane-item-content">
                <p class="content-name">退费（元）</p>
                <p class="content-num">{{ [data.currentTotalAmt, 2] | toLocalString }}</p>
              </div>
            </div>
            <div class="plane-item">
              <div class="plane-item-content">
                <p class="content-name">当前教务服务方基础班已退费工单（笔）</p>
                <p class="content-num">{{ data.currentBaseNum | toLocalString }}</p>
              </div>
              <div class="plane-item-content">
                <p class="content-name">退费（元）</p>
                <p class="content-num">{{ [data.currentBaseAmt, 2] | toLocalString }}</p>
              </div>
            </div>
            <div class="plane-item">
              <div class="plane-item-content">
                <p class="content-name">当前教务服务方标准班已退费工单（笔）</p>
                <p class="content-num">{{ data.currentStandardNum | toLocalString }}</p>
              </div>
              <div class="plane-item-content">
                <p class="content-name">退费（元）</p>
                <p class="content-num">{{ [data.currentStandardAmt, 2] | toLocalString }}</p>
              </div>
            </div>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 招生服务方 -->
    <div v-else-if="type === 2" class="pandect-module">
      <el-row type="flex" align="middle" class="module-title-line">
        <i class="title-icon icon-trend" />
        <p class="title-text">招生服务方总数据</p>
      </el-row>
      <div class="total-data-plane">
        <el-row type="flex" justify="space-between" align="middle" class="plane-container total-plane plane-line">
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">当前招生服务方全部班型已退费工单（笔）</p>
              <p class="content-num">{{ data.totalNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">退费（元）</p>
              <p class="content-num">{{ [data.totalAmt, 2] | toLocalString }}</p>
            </div>
          </div>
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">当前招生服务方基础班已退费工单（笔）</p>
              <p class="content-num">{{ data.baseNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">退费（元）</p>
              <p class="content-num">{{ [data.baseAmt, 2] | toLocalString }}</p>
            </div>
          </div>
          <div class="plane-item">
            <div class="plane-item-content">
              <p class="content-name">当前招生服务方标准班已退费工单（笔）</p>
              <p class="content-num">{{ data.standardNum | toLocalString }}</p>
            </div>
            <div class="plane-item-content">
              <p class="content-name">退费（元）</p>
              <p class="content-num">{{ [data.standardAmt, 2] | toLocalString }}</p>
            </div>
          </div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Plane',

  props: {
    type: {
      type: Number,
      require: true
    },
    data: {
      type: Object,
      require: true
    }
  }
}
</script>

<style lang="scss" scoped>
.pandect-module,
.agent-pandect-module {
  width: 100%;
  max-width: 1540px;
  padding-top: 32px;
  overflow: hidden;
}


.plane-container {
  width: 100%;
  height: auto;
  background-color: #FFFFFF;
  border-radius: 8px;
  &.total-plane {
    background: #FFFFFF url('../../../../assets/images/platform/bg_circle.png') no-repeat 101% 0 / 174px 162px;
  }
  & + & {
    margin-top: 16px;
  }
}
.plane-line {
  width: 100%;
  height: 124px;
  box-sizing: border-box;
  flex-wrap: nowrap;
  .plane-item {
    display: flex;
    width: 33%;
    box-sizing: border-box;
    padding: 0 2%;
    position: relative;
    white-space: nowrap;
    font-size: 0;
    &:first-child {
      width: 32%;
      padding-left: 2%;
      .content-num {
        color: #2C8CF0;
      }
    }
    &:last-child {
      width: 35%;
      padding-right: 4%;
    }
    & + .plane-item {
      &::before {
        display: block;
        content: '';
        width: 0px;
        height: 56px;
        border-left: 1px solid #E8E8E8;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
    }
  }
  &.total-plane {
    .plane-item-content {
      .content-name,
      .content-num {
        font-weight: 600;
      }
    }
  }
}
.plane-item-content {
  box-sizing: border-box;
  .content-name {
    margin-right: -10%;
    line-height: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
    color: #2F2F2F;
  }
  .content-num {
    padding-top: 8px;
    font-family: DIN-Regular, DIN;
    line-height: 32px;
    white-space: nowrap;
    font-size: 26px;
    color: #2F2F2F;
  }
  &:first-child {
    width: 52%;
  }
  &:last-child {
    flex: 1;
    margin-left: 10%;
  }
}

</style>
